import {takeEvery} from 'redux-saga';
import {$index, $delete, $post, $put} from '../_utils/restSaga';

import {
  FETCH_USERS,
  DELETE_USER,
  MODIFY_USER,
  ADD_USER,
  fetchUsersSuccess,
  fetchUsersFailure,
  deleteUserSuccess,
  deleteUserFailure,
  modifyUserSuccess,
  modifyUserFailure,
  addUserSuccess,
  addUserFailure
} from './actions';


export default function*() {
  yield [
    takeEvery(FETCH_USERS.do, $index('/api/user',
      fetchUsersSuccess, fetchUsersFailure)),
    takeEvery(DELETE_USER.do, $delete('/api/user/#{id}',
      deleteUserSuccess, deleteUserFailure)),
    takeEvery(MODIFY_USER.do, $put('/api/user/#{id}',
      modifyUserSuccess, modifyUserFailure)),
    takeEvery(ADD_USER.do, $post('/api/user',
      addUserSuccess, addUserFailure))
  ];
}



// WEBPACK FOOTER //
// ./src/redux/users/saga.js